<div class="modal-body">
  <lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>

  <div class="form-group">
    <div dropdown autoClose="outsideClick" class="dropdown text-end">
      <div class="booking-options href">
        <button id="incidentDropdownToggle" class="btn btn-info btn-block btn-incident" dropdownToggle>
          <span class="incident-text">{{ selectedIncident | translate }}</span>
          <i class="icon-dropdown pull-right"></i>
        </button>
      </div>
      <ul class="dropdown-menu pull-right incident-dropdown" id="incidentsDropdown" *dropdownMenu role="menu">
        <li *ngFor="let incident of incidentTypes">
          <a
            [id]="'selectIncident_' + incident"
            [attr.data-incident]="incident"
            class="href"
            (click)="selectIncident(incident)"
            >{{ incident | translate }}</a
          >
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="showStorageLocationTelephone" class="mt-4">
    <p>
      {{ 'WOULD_YOU_LIKE_TO_CALL_THE_LOCATION' | translate }}
      <a class="href" href="tel:{{ storageLocationTelephoneNumber }}">{{ storageLocationTelephoneNumber }}</a>
    </p>
  </div>
  <div *ngIf="acceptIncidentImage" class="mt-4">
    <p>{{ 'INCIDENT_TAKE_PICTURE_AND_MAKE_A_NOTE' | translate }}</p>
    <!-- Hidden input for native camera or file picker -->
    <input
      id="incidentImageInput"
      name="incidentImageInput"
      type="file"
      class="incident-image-input"
      capture="environment"
      [uploader]="uploader"
      [accept]="uploader.options.allowedMimeType.join(',')"
      ng2FileSelect
    />

    <!-- Image and call-to-action for taking photo of the luggage -->
    <label class="take-photo" for="incidentImageInput">
      <div class="image-container">
        <div class="image-spinner">
          <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
        </div>
        <img
          *ngIf="!isLoading && !localIncidentImage && !remoteIncidentImage"
          src="/assets/lugggagehero_piktogrammer_selfservice_incident1.png"
        />
        <img
          *ngIf="!isLoading && !localIncidentImage && remoteIncidentImage"
          [imageName]="remoteIncidentImage"
          imageSize="medium"
          lhImage
        />
        <img
          *ngIf="!isLoading && localIncidentImage"
          [src]="localIncidentImage | safeUrl"
          (load)="onLocalImageLoad($event)"
          class="local"
        />
      </div>

      <div class="camera-cta">
        <a class="btn btn-lg btn-warning">
          <i class="camera-icon d-block mb-1">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <title>camera</title>
              <path
                d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
              ></path>
            </svg>
          </i>
        </a>
      </div>
    </label>
  </div>

  <div class="form-group" [class.mt-4]="!showStorageLocationTelephone" *ngIf="isIncidentSelected">
    <p *ngIf="!acceptIncidentImage">
      <span *ngIf="showStorageLocationTelephone">{{ 'OTHERWISE_MAKE_NOTE_AND_REPORT' | translate }}</span>
      <span *ngIf="!showStorageLocationTelephone">{{ 'MAKE_NOTE_AND_REPORT' | translate }}</span>
    </p>
    <textarea
      class="form-control comments-input"
      type="text"
      autocomplete="off"
      rows="3"
      maxlength="5000"
      [(ngModel)]="comments"
      [placeholder]="commentsPlaceholder"
    >
    </textarea>
  </div>

  <div class="d-flex flex-column mt-4" *ngIf="isCancelBookingVisible">
    <span>{{ 'DO_YOU_WANT_TO_CANCEL_YOUR_BOOKING' | translate }}</span>
    <div class="checkbox mt-3">
      <label for="cancelBookingCheckbox">
        <input
          type="checkbox"
          name="cancelBookingCheckbox"
          id="cancelBookingCheckbox"
          [(ngModel)]="isCancelBookingSelected"
        />
        {{ 'YES_CANCEL_MY_BOOKING' | translate }}
      </label>
    </div>
  </div>

  <button
    id="submitIncidentReport"
    type="button"
    class="btn btn-block btn-primary mt-4"
    (click)="submitIncidentReport()"
    [disabled]="!isSubmitAllowed"
  >
    <span *ngIf="isCancelBookingSelected">{{ 'REPORT_INCIDENT_AND_CANCEL' | translate }}</span>
    <span *ngIf="!isCancelBookingSelected">{{ 'REPORT_INCIDENT' | translate }}</span>
  </button>
</div>
